import { render, staticRenderFns } from "./highlight-substring.component.vue?vue&type=template&id=c60581e6&scoped=true"
import script from "./highlight-substring.component.vue?vue&type=script&lang=ts"
export * from "./highlight-substring.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60581e6",
  null
  
)

export default component.exports